import { render } from "./chef-kitchen-page.vue?vue&type=template&id=5dd2ed7f&scoped=true"
import script from "./chef-kitchen-page.vue?vue&type=script&lang=js"
export * from "./chef-kitchen-page.vue?vue&type=script&lang=js"

import "./chef-kitchen-page.vue?vue&type=style&index=0&id=5dd2ed7f&lang=scss&scoped=true"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd2ed7f"]])

export default __exports__